module.exports = [{
      plugin: require('../../plugins/gatsby-source-marketo-lucid/gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../../plugins/gatsby-plugin-browser-lucid/gatsby-browser.tsx'),
      options: {"plugins":[],"enabledLanguages":["en","ru","it","sv","da","ko","pl"]},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-N2HJB2Q","includeInDevelopment":false,"defaultDataLayer":null,"routeChangeEventName":"gatsby-route-change","enableWebVitalsTracking":false,"selfHostedOrigin":"https://www.googletagmanager.com","selfHostedPath":"gtm.js"},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
